/**
 * 앱 안의 브라우저(인앱 브라우저)인가.
 *
 * 카카오톡으로 공유한 링크를 누르면 사이트가 **카카오톡 안의 브라우저**로 열린다.
 * 이런 브라우저는 팝업을 진짜 창으로 만들지 않아서, 팝업으로 하는 소셜 로그인이
 * 결과를 넘길 "원래 창"(`window.opener`)을 찾지 못한다. 그래서 여기서는 팝업 대신
 * 페이지 전체를 이동시키는 로그인을 쓴다. (2026-09-17)
 *
 * ★ 판별이 빗나가도 로그인이 막히지는 않는다. 팝업 화면(백엔드 kakao.html)이 원래
 *   창을 못 찾으면 스스로 사이트로 돌아가 로그인을 마친다. 이 판별은 그 한 바퀴를
 *   아끼는 용도다.
 *
 *   KAKAOTALK      카카오톡
 *   NAVER(inapp    네이버 앱
 *   Instagram      인스타그램
 *   FBAN|FBAV|FB_IAB  페이스북
 *   Line/          라인
 *   DaumApps       다음 앱
 *   everytimeApp   에브리타임
 *   BAND/          밴드
 *   ; wv)          안드로이드 웹뷰 일반
 */
const IN_APP_PATTERN =
  /KAKAOTALK|NAVER\(inapp|Instagram|FBAN|FBAV|FB_IAB|Line\/|DaumApps|everytimeApp|BAND\/|; wv\)/i;

export function isInAppBrowser(
  ua: string = typeof navigator === 'undefined' ? '' : navigator.userAgent
): boolean {
  return IN_APP_PATTERN.test(ua);
}
